<template>
  <BModal v-model="isOpen" size="lg" centered hide-footer hide-header>
    <LocationDetails />
  </BModal>
</template>

<script>
import { BModal } from 'bootstrap-vue';
import LocationDetails from './LocationDetails';

export default {
  components: {
    BModal,
    LocationDetails,
  },
  computed: {
    isOpen: {
      get() {
        return this.$store.state.locations.locationModal.isOpen;
      },
      set(val) {
        this.$store.commit('locations/resetLocationModal');
        this.$store.commit('locations/locationModal', { isOpen: val });
      },
    },
  },
};
</script>
